<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm"><span class="bold">ACKNOWLEDGEMENTS</span></h2>
<p class="noindent"><span class="dropcaps">O</span>ur thanks go to R.A. Cooke for use of his <em class="italic">Track Layout Diagrams</em> and <em class="italic">Gazetteer of the Coal Mines of South Wales &amp; Monmouthshire</em> for information on the collieries north of Bargoed, to Keith Jones of Mountain Ash and Malcolm James of Rogerstone for the use of the many Sid Rickard photographs now held in their J&amp;J Collection. Thanks also to Ian Reece for help with editing and Michael Roach, Jeff Stone and Garth Tilt for the use of their photos from their visits to the line and to Ken Mumford for material from his B&amp;M presentation.</p>
<p class="indent">Every effort has been made to identify the copyright holder for photographs and other material used. Where this has not been possible, please contact <span class="weblink"><a href="mailto:john_hodge@tiscali.co.uk"><span class="underline">john_hodge@tiscali.co.uk</span></a></span> by email if there is a need to rectify the position.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?72b8cd8d